import React, { useRef } from "react";
import MainImage5 from "../../assets/VA/VAMAIN4.jpg";
import AboutImage from "../../assets/AboutImage7.jpg";

// Importing images from the assets folder
import TestimonyImage1 from "../../assets/VisibilityAudit/VisibilityAudit4.png";
import TestimonyImage2 from "../../assets/VisibilityAudit/VisibilityAudit2.png";
// import TestimonyImage3 from '../../assets/VisibilityAudit/VisibilityAudit3.png';
import TestimonyImage4 from "../../assets/VisibilityAudit/VisibilityAudit11.png";
import TestimonyImage5 from "../../assets/VisibilityAudit/VisibilityAudit5.png";
import TestimonyImage6 from "../../assets/VisibilityAudit/VisibilityAudit6.png";
import TestimonyImage7 from "../../assets/VisibilityAudit/VisibilityAudit7.png";
import TestimonyImage8 from "../../assets/VisibilityAudit/VisibilityAudit8.png";
import TestimonyImage9 from "../../assets/VisibilityAudit/VisibilityAudit9.png";
import TestimonyImage10 from "../../assets/VisibilityAudit/VisibilityAudit10.png";
import TestimonyImage11 from "../../assets/VisibilityAudit/VisibilityAudit.png";
import SmallTestimony from "../../components/SmallTestimony";
import Footer from "../../components/Footer";
import About from "../../components/About";
import NavLite from "../../components/NavLite";

function VisibilityAudit() {
  <main>
  <title>Get a Visibility Audit | Identify SEO Gaps for Your Women-Led Brand | Her Growth Co</title>
<meta
name="description"
content="Uncover what’s holding your site back. Our free SEO audit helps women entrepreneurs boost rankings, visibility, and conversions through expert insights."
/>
<meta
name="keywords"
content="seo services austin, local seo agency texas, niche seo for consultants, expert seo for coaches, texas seo consultant, google business profile seo texas, seo keyword research services, austin link building services, seo for service businesses texas, female entrepreneur seo austin, technical seo expert austin, seo agency for small business, seo for personal brands texas, organic seo services texas, austin seo campaign management, seo lead generation austin, online visibility services austin, targeted seo strategies texas, seo for niche industries, austin digital footprint growth, seo services for creatives texas, top-ranking seo agency austin, seo for women-owned brands texas, local business seo optimization austin, female founder seo fort worth, female founder seo houston, conversion optimization austin, cro services texas, website a/b testing texas, advanced cro agency, landing page optimization austin, heatmap analysis websites, austin lead conversion strategy, high-converting website audits, digital behavior analysis, improve website conversions austin, website optimization for sales, cro for female entrepreneurs, sales funnel optimization austin, austin conversion rate experts, ux testing for conversions, cro for personal brands texas, conversion-optimized websites, texas lead capture solutions, premium cro consultants austin, website user experience testing, conversion tracking for websites, web strategy for high-ticket leads, roi-focused website optimization, data-driven cro services, website behavior analytics austin
"
/>
</main>
  const containerRef = useRef(null);

  const handleScrollLeft = () => {
    if (containerRef.current) {
      containerRef.current.scrollBy({ left: -1040, behavior: "smooth" }); // Scroll by the width of 4 items (250px each)
    }
  };

  const handleScrollRight = () => {
    if (containerRef.current) {
      containerRef.current.scrollBy({ left: 1040, behavior: "smooth" }); // Scroll by the width of 4 items (250px each)
    }
  };

  // Array of testimonials with image sources
  const testimonials = [
    { image: TestimonyImage1, name: "David James", role: "CEO/Chairman" },
    { image: TestimonyImage2, name: "Sarah Lee", role: "Founder" },
    // { image: TestimonyImage3, name: "James Smith", role: "Marketing Director" },
    { image: TestimonyImage4, name: "Emily White", role: "Product Manager" },
    { image: TestimonyImage5, name: "Michael Brown", role: "CTO" },
    { image: TestimonyImage6, name: "Linda Green", role: "COO" },
    { image: TestimonyImage7, name: "Emily White", role: "Product Manager" },
    { image: TestimonyImage8, name: "Michael Brown", role: "CTO" },
    { image: TestimonyImage9, name: "Linda Green", role: "COO" },
    { image: TestimonyImage10, name: "Linda Green", role: "COO" },
    { image: TestimonyImage11, name: "Linda Green", role: "COO" },
  ];

  return (
    <main className="relative min-h-screen w-screen overflow-x-hidden bg-[#F4F3E1 ]">
      <title>SEO Visibility Audit: Boost Website Traffic & Conversions | Her Growth Co | Boost Your Website's Visibility: SEO Audit Package</title>
<meta
  name="description"
  content="Identify website issues with our SEO Visibility Audit. We analyze speed, SEO, mobile & UX, providing actionable insights to boost traffic and conversions. Book your audit today!"
/>
<meta
  name="keywords"
  content="seo visibility audit, website audit, website analysis, website speed analysis, mobile responsiveness check, ux audit, local seo assessment, on page seo review, website optimization, website conversion, digital marketing audit, website performance, website strategy, women owned business website audit, law firm website audit, consulting website audit, finance website audit, life coach website, life coach websites, life coaching websites, coaching websites, coaching website, best life coaching websites, speaker and life coach wordpress theme free, buy website template, web design company houston, seo financial advisors, financial advisor websites, seo for finance, front end web designers women, web developer portfolio projects, web design new york, website design company near me, law firm web design women, consulting website women, finance web design women, SEO for women lawyers, web design for women consultants, marketing for women finance companies, women owned legal SEO, web design for women accountants, SEO for women financial advisors, website design for women business coaches"
/>
      <section>
        <div
          className="relative bg-cover bg-center h-auto"
          style={{ backgroundImage: `url(${MainImage5})` }}
        >
<NavLite/>

          <div className="flex flex-col max-w-2xl py-12 md:py-16 lg:py-10 gap-10 ml-10 ">
            <div className="flex flex-col items-start gap-y-5 bg-black/1 backdrop-blur-sm">
              {" "}
              {/* items-start here */}
              <h1 className="text-left text-3xl font-bold md:text-5xl text-white uppercase ">
                {" "}
                {/* text-left here */}
                <span className="bg-[#CFF098] text-black">
                  {" "}
                  Outrank Competitors
                </span>{" "}
                Attact Clients, Improve SEO:
                <span className="bg-[#CFF098] text-black">$99.99</span> SEO
                Visibility Audit.
              </h1>
              <p className="text-left text-white bg-black/1 backdrop-blur-sm max-w-2xl text-xl font-bold italic">
                {" "}
                {/* text-left here */}
                Discover the exact roadblocks preventing your website from
                attracting premium clients. Get a personalized plan to boost
                your online presence and convert visitors.
              </p>
            </div>
            <div className="flex flex-col gap-4 font-regular sm:flex-row">
              <a
                href="https://cal.com/woaomwebdesign/15min"
                className="flex rounded-full items-center gap-4 bg-[#CFF098] px-6 py-3 text-black border-[1px] border-black shadow-md"
              >
                <p>Schedule Your Visibility Audit Now</p>
              </a>
            </div>
          </div>
        </div>

        <section className="bg-[#F7F3F2]">
          <div className="mx-auto w-full max-w-7xl px-5 py-16 md:px-10 md:py-20">
            <div className="flex flex-col items-center text-center">
              <div className="flex items-center rounded-md px-3 py-1">
                <p className="text-sm uppercase mb-12 text-black">
                  Visibility Audit
                </p>
              </div>
              <h2 className="text-3xl font-regular md:text-5xl text-black max-w-2xl">
                Your Roadmap to{" "}
                <span className="bg-[#CFF098] text-black font-semibold italic">
                  Online Success
                </span>
                : What's Included in Your Visibility Audit.
              </h2>
              <p className="mb-8 mt-4 max-w-lg text-base text-black md:mb-12 md:text-lg font-light">
                Our Visibility Audit is designed to give you a clear, actionable
                understanding of your website's performance. We'll identify key
                areas for improvement and provide a comprehensive report and
                personalized recommendations.
              </p>
            </div>

            <div className="grid gap-5 sm:grid-cols-2 md:grid-cols-3 md:gap-4 mb-10">
              <div className="grid gap-6 border border-solid border-black p-8 md:p-10">
                <h3 className="text-xl font-semibold text-black uppercase">
                  Website Speed Analysis
                </h3>
                <p className="text-black text-lg mb-10 font-light">
                  Pinpoint and fix speed bottlenecks with Google PageSpeed
                  Insights.
                </p>
              </div>

              <div className="grid gap-6 border border-solid border-black p-8 md:p-10 ">
                <h3 className="text-xl font-semibold text-black uppercase">
                  Mobile Responsiveness Check
                </h3>
                <p className="text-black text-lg mb-10 font-light">
                  Ensure a seamless experience on all devices, preventing lost
                  leads.
                </p>
              </div>
              <div className="grid gap-6 border border-solid border-black p-8 md:p-10">
                <h3 className="text-xl font-semibold text-black uppercase">
                  On-Page SEO Review
                </h3>
                <p className="text-black text-lg mb-10 font-light">
                  Optimize title tags, meta descriptions, header tags, and more
                  for better search rankings.
                </p>
              </div>
            </div>

            <div className="grid gap-5 sm:grid-cols-2 md:grid-cols-3 md:gap-4 mb-10">
              <div className="grid gap-6 border border-solid border-black p-8 md:p-10">
                <h3 className="text-xl font-semibold text-black uppercase">
                  Local SEO Assessment
                </h3>
                <p className="text-black text-lg mb-10 font-light">
                  Maximize your local presence with a Google Business Profile
                  and citation review.
                </p>
              </div>

              <div className="grid gap-6 border border-solid border-black p-8 md:p-10">
                <h3 className="text-xl font-semibold text-black uppercase">
                  User Experience (UX) Highlights
                </h3>
                <p className="text-black text-lg mb-10 font-light">
                  Identify and eliminate usability issues that hinder
                  conversions.
                </p>
              </div>
              <div className="grid gap-6 border border-solid border-black p-8 md:p-10">
                <h3 className="text-xl font-semibold text-black uppercase">
                  Personalized Loom Walkthrough
                </h3>
                <p className="text-black text-lg mb-10 font-light">
                  Get a clear, actionable video explanation of your audit
                  findings.
                </p>
              </div>
            </div>

            <div className="grid gap-5 sm:grid-cols-2 md:grid-cols-3 md:gap-4">
              <div className="grid gap-6 border border-solid border-black p-8 md:p-10">
                <h3 className="text-xl font-semibold text-black uppercase">
                  Detailed Written Report
                </h3>
                <p className="text-black text-lg mb-10 font-light">
                  A comprehensive summary with step-by-step recommendations.
                </p>
              </div>

              <div className="grid gap-6 border border-solid border-black p-8 md:p-10">
                <h3 className="text-xl font-semibold text-black uppercase">
                  10 Local Keywords
                </h3>
                <p className="text-black text-lg mb-10 font-light">
                  A list of 10 local keywords that will help your business to be
                  found.
                  <br />{" "}
                  <span className="text-black bg-[#CFF098] text-sm font-light max-w-[240px]">
                    *Limited Time Offer - All April 2025
                  </span>
                </p>
              </div>
            </div>

            <div className="flex flex-col items-center justify-center mt-10">
              <button className="text-black bg-[#CFF098] rounded-full px-6 py-2 border-[1px] border-black">
                BOOK A Visibility Audit →
              </button>
              <p className="text-black text-lg font-light mt-6 w-[400px] text-center">
                No prep needed! Just come talk & we’ll figure it out together.
              </p>
            </div>
          </div>
        </section>

        <section>
          <div className="mx-auto w-full max-w-7xl px-5 py-16 md:px-10 md:py-10 ">
            <div className="mb-4 grid grid-cols-1 md:grid-cols-2 gap-8 items-start">
              <h2 className="text-3xl font-semibold max-w-lg mt-8 sm:mt-28">
                <span className="bg-[#CFF098] text-black italic">
                  More Packages
                </span>{" "}
                We Offer.
              </h2>
              <div className="space-y-4 ">
                <h4>Elite & Visible ($3999):</h4>
                <p className="text-sm text-gray-300 max-w-lg">
                  You will get a custom, mobile-responsive website with
                  optimized local SEO, service pages, an authority-building
                  'About' page, content marketing foundation, analytics
                  tracking, and training, plus optional add-ons like copywriting
                  and ongoing SEO.
                </p>
                <a href="/elitevisible">
                <button className="text-black bg-[#CFF098] rounded-full px-6 py-2 border-[1px] border-black">
                View Elite & Visible Package  →
                </button>
                </a>
                <h4 className="pt-4">Local SEO Accelerator Package ($499):</h4>
                <p className="text-sm text-gray-300 max-w-lg">
                  You will get targeted local SEO optimization, including GBP
                  optimization, citation building, keyword research, review
                  management, content optimization, performance reporting, and a
                  strategy session, to quickly boost local visibility for
                  professional service providers.
                </p>
                <a href="/localseo">
                <button className="text-black bg-[#CFF098] rounded-full px-6 py-2 border-[1px] border-black">
                View Local SEO Accelerator Package  →
                </button>
                </a>
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4"></div>
          </div>
        </section>

        {/* Our Projects */}

        <section className="">
          <div className="bg-[#F7F3F2] h-auto">
            <h2 className="text-center text-2xl font-bold md:text-3xl text-black pt-16 mb-16 uppercase">
              Our{" "}
              <span className="bg-[#CFF098] text-black italic">
                Visibility Audit
              </span>{" "}
              Projects
            </h2>

            {/* Left Arrow Button */}
            <button
              className="absolute top-1/2 left-0 transform -translate-y-1/2 z-10 p-6 pt-28"
              onClick={handleScrollLeft}
            >
              {/* Left Arrow SVG */}
              {/* <svg
                width="50"
                height="50"
                viewBox="0 0 72 73"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="0.5"
                  y="1"
                  width="71"
                  height="71"
                  rx="35.5"
                  stroke="#000000" // White color for the background circle stroke
                />
                <path
                  d="M44 35.5H31.83L37.42 29.91L36 28.5L28 36.5L36 44.5L37.41 43.09L31.83 37.5H44V35.5Z"
                  fill="#000000" // White color for the arrow itself
                />
              </svg> */}
            </button>

            <div className="relative flex items-center justify-center">
              <div
                ref={containerRef}
                className="flex overflow-x-auto gap-28 py-6 scroll-smooth scroll-m-0  max-w-[1040px] w-full" // Limit the width to 4 items
              >
                {testimonials.map((testimonial, index) => (
                  <div key={index} className="min-w-[650px]">
                    <img
                      className="object-cover w-full h-auto"
                      src={testimonial.image} // Display the image from assets
                      alt={`Testimonial ${index + 1}`}
                    />
                  </div>
                ))}
              </div>
            </div>

            {/* Right Arrow Button */}
            <button
              className="absolute top-1/2 right-0 transform -translate-y-1/2 z-10 p-6 pt-28"
              onClick={handleScrollRight}
            >
              {/* Right Arrow SVG */}
              {/* <svg
              width="50"
              height="50"
              viewBox="0 0 72 73"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="0.5"
                y="1"
                width="71"
                height="71"
                rx="35.5"
                stroke="#000000" // White color for the background circle stroke
              />
              <path
                d="M36 28.5L34.59 29.91L40.17 35.5H28V37.5H40.17L34.59 43.09L36 44.5L44 36.5L36 28.5Z"
                fill="#000000" // White color for the arrow itself
              />
            </svg> */}
            </button>
          </div>
        </section>

        <SmallTestimony />

        <section
          className="bg-cover bg-center"
          style={{ backgroundImage: `url(${AboutImage})` }}
        >
          <div className="">
            <div className="mx-auto w-full text-center bg-[#000000] bg-opacity-60 p-6">
              <h2 className="mx-auto mb-2 max-w-3xl flex-col text-3xl font-bold md:mb-6 md:text-4xl lg:mb-6  text-white ">
                Ready to Unlock Your Website's{" "}
                <span className="bg-[#CFF098] text-black italic">
                  Potential
                </span>
                ?
              </h2>
              <p className="mx-auto mb-2 max-w-xl text-sm text-gray-300 sm:text-base md:mb-4">
                Don't let your website hold you back. Schedule your Visibility
                Audit today and take the first step towards online success.
              </p>
              <a
                href="/"
                className="mb-4 inline-block text-black bg-[#CFF098] rounded-full px-6 py-2 border-[1px] border-black"
              >
                Book Your Visibility Audit Now
              </a>
            </div>
          </div>
        </section>

        <About />

        <Footer />
      </section>
    </main>
  );
}

export default VisibilityAudit;
